import createSvgIcon from "./utils/create_icon"

const HeadphonesOutline = createSvgIcon(<path clipRule="evenodd" d="M5 12a7 7 0 0 1 14 0h-3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h1a4 4 0 0 0 4-4v-5a9 9 0 1 0-18 0v5a4 4 0 0 0 4 4h1a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1zm0 2v3a2 2 0 0 0 2 2v-5zm14 3v-3h-2v5a2 2 0 0 0 2-2z" fill="currentColor" fillRule="evenodd" />, "HeadphonesOutline")
export default HeadphonesOutline
